// @flow
import React, { Fragment, useState, useCallback } from 'react'
import { ReactI18NextChild } from 'react-i18next'

import Modal, { ModalHeader } from 'app/common/components/Modal'

import { EditGroceryKitForm } from './EditGroceryKitForm'
import styles from './EditKit.scss'
import { DietFoodTypeId } from 'app/dataTypes/org/dietFoodTypes'

type Props = {
  kitId: number // если не указан, создается новый комплект
  orgId: number
  buildingId?: number // вариант для корпуса
  dietFoodTypeId?: DietFoodTypeId // опционально, вариант вида диет. питания
  date: string
  children?: (toggle: () => void) => ReactI18NextChild
  onSuccess?: () => void
}

export const EditGroceryKit = ({
  kitId,
  orgId,
  buildingId,
  dietFoodTypeId,
  date,
  children,
  onSuccess,
}: Props) => {
  const [modalVisible, setModalVisible] = useState(false)
  const toggleModal = useCallback(() => {
    setModalVisible((appear_) => !appear_)
  }, [])

  if (!children) {
    return null
  }

  return (
    <Fragment>
      {children(toggleModal)}
      {modalVisible && (
        <Modal toggleModal={toggleModal} className={styles.root}>
          <ModalHeader className={styles.header}>
            {'Редактирование стоимости продуктового набора'}
          </ModalHeader>

          <EditGroceryKitForm
            kitId={kitId}
            orgId={orgId}
            buildingId={buildingId}
            dietFoodTypeId={dietFoodTypeId}
            date={date}
            toggleModal={toggleModal}
            onSuccess={onSuccess}
          />
        </Modal>
      )}
    </Fragment>
  )
}
